export default __webpack_public_path__ + "static/media/professionalDetailshelpMobileHighlight@2x.f6e9ab44.png";